// tslint:disable
export var Gender;
(function (Gender) {
    // UNKN
    Gender[Gender["UNKN"] = 0] = "UNKN";
    // M
    Gender[Gender["M"] = 1] = "M";
    // F
    Gender[Gender["F"] = 2] = "F";
    // I
    Gender[Gender["I"] = 3] = "I";
})(Gender || (Gender = {}));
//# sourceMappingURL=Gender.js.map